<template>
  <div>
      <!-- 头部 -->
      <div v-show="!isWeixin" class="head">
        <img class="img_arrow" src="@/assets/test/return.png" alt @click="goBack()">
        <p class="my_title">评论列表</p>
        <span></span>
      </div>
      <!-- 回到顶部 -->
      <!-- <div class="goTop">
        <img v-show="is_buy!=0&&loadIsBuy" src="@/assets/myicon/subm.png" alt="" @click="submit()">
        <a href="#here"><img src="@/assets/myicon/gotop.png" alt="" @click="go_top()"></a>
      </div> -->
      <Assess ref="assClick"></Assess>
      <span>
        <button class="comment" @click="goComment">我要评论</button>
      </span>
  </div>
</template>

<script>
import { isAddComment ,getIsBuy} from '@/api/book.js'
import tool from '@/utils/tools.js'
import isWeixin from '@/utils/isWechat.js'
import wx from 'weixin-js-sdk'
import Cookies from 'js-cookie'
import Assess from '@/components/course/bookAssess.vue'

export default {
  components: {
    Assess
  },
  data() {
    return {
      isWeixin:false,
      book_id:this.$route.query.book_id,
      is_buy:0
    }
  },
  created() {
  },
  mounted() {
    this.getStatus()
    this.uid = Cookies.get('uid')
    document.title = '评论列表'
    // wx.miniProgram.postMessage({ data: { title: '请选择图书' }})
    // if (this.$route.query.lesson_name) {
    //   this.lesson_name = this.$route.query.lesson_name
    // }
    this.isWeixin = isWeixin
  },
  methods: {
    // 评价
    // goComment() {
    //   if (!this.checkCodetypeAppLogin()) {
    //     return
    //   }
    //   this.is_buy = 1
    //   if (this.is_buy) {
    //     this.$router.push({ path: '/comment', query: { lesson_id: this.lesson_id }})
    //   } else {
    //     this.$toast(
    //       '请购买产品后参与评价'
    //     )
    //   }
    // },
    // 判断图书是否购买
    getStatus(){
      getIsBuy().then((res)=>{
        this.is_buy = res
      })
    },
    goComment() {
      // 检测app内是否登录
      if (!this.checkCodetypeAppLogin()) {
        return
      }
      // this.is_buy = 1
      if (this.is_buy) {
        const info = {
          book_id: this.book_id,
          common_type: 5
        }
        isAddComment(info).then(res => {
          if (res.errNo == 0) {
            this.$router.push({ path: '/bookComment', query: { book_id: this.book_id, book_name: this.$route.query.book_name }})
          } else if (res.errNo == 99) {
            this.$toast({
              message: '已经评价，不可再次评价'
            })
          }
        })
      } else {
        this.$toast({
          message: '请购买图书后参与评价'
        })
      }
    },
    // 检测是否登录
    checkCodetypeAppLogin() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          if (this.code_type == 1 && !this.isLogin) {
            window.webkit.messageHandlers.vue_showAppLogin.postMessage('')
            return false
          }
        }
      }
      return true
    },
    // 返回
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp',
            '课程详情返回',
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
          this.$router.go(-1)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  border-bottom: 1px solid #eee;
  z-index: 1;
}
.img_arrow {
  width: 50px;
  height: 55px;
  padding-left: 30px;
  padding-top: 9px;
}
.my_title {
  font-weight: 500;
  color: #333;
  font-size: 36px;
  /* font-weight: 600; */
  letter-spacing: 2px;
  padding-right: 70px;
}
// 我要评价
.comment {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 97px;
  background-color: #ef2d2e;
  color: #fff;
  font-size: 28px;
}
</style>
